var B = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, l = "1.9.0", O = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function F(e) {
  var r = /* @__PURE__ */ new Set([e]), t = /* @__PURE__ */ new Set(), n = e.match(O);
  if (!n)
    return function() {
      return !1;
    };
  var o = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (o.prerelease != null)
    return function(s) {
      return s === e;
    };
  function a(u) {
    return t.add(u), !1;
  }
  function i(u) {
    return r.add(u), !0;
  }
  return function(s) {
    if (r.has(s))
      return !0;
    if (t.has(s))
      return !1;
    var f = s.match(O);
    if (!f)
      return a(s);
    var p = {
      major: +f[1],
      minor: +f[2],
      patch: +f[3],
      prerelease: f[4]
    };
    return p.prerelease != null || o.major !== p.major ? a(s) : o.major === 0 ? o.minor === p.minor && o.patch <= p.patch ? i(s) : a(s) : o.minor <= p.minor ? i(s) : a(s);
  };
}
var K = F(l), U = l.split(".")[0], g = Symbol.for("opentelemetry.js.api." + U), y = B;
function w(e, r, t, n) {
  var o;
  n === void 0 && (n = !1);
  var a = y[g] = (o = y[g]) !== null && o !== void 0 ? o : {
    version: l
  };
  if (!n && a[e]) {
    var i = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return t.error(i.stack || i.message), !1;
  }
  if (a.version !== l) {
    var i = new Error("@opentelemetry/api: Registration of version v" + a.version + " for " + e + " does not match previously registered API v" + l);
    return t.error(i.stack || i.message), !1;
  }
  return a[e] = r, t.debug("@opentelemetry/api: Registered a global for " + e + " v" + l + "."), !0;
}
function h(e) {
  var r, t, n = (r = y[g]) === null || r === void 0 ? void 0 : r.version;
  if (!(!n || !K(n)))
    return (t = y[g]) === null || t === void 0 ? void 0 : t[e];
}
function E(e, r) {
  r.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + l + ".");
  var t = y[g];
  t && delete t[e];
}
var X = function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var n = t.call(e), o, a = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      o && !o.done && (t = n.return) && t.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}, W = function(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}, Y = (
  /** @class */
  function() {
    function e(r) {
      this._namespace = r.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return d("debug", this._namespace, r);
    }, e.prototype.error = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return d("error", this._namespace, r);
    }, e.prototype.info = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return d("info", this._namespace, r);
    }, e.prototype.warn = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return d("warn", this._namespace, r);
    }, e.prototype.verbose = function() {
      for (var r = [], t = 0; t < arguments.length; t++)
        r[t] = arguments[t];
      return d("verbose", this._namespace, r);
    }, e;
  }()
);
function d(e, r, t) {
  var n = h("diag");
  if (n)
    return t.unshift(r), n[e].apply(n, W([], X(t), !1));
}
var c;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(c || (c = {}));
function q(e, r) {
  e < c.NONE ? e = c.NONE : e > c.ALL && (e = c.ALL), r = r || {};
  function t(n, o) {
    var a = r[n];
    return typeof a == "function" && e >= o ? a.bind(r) : function() {
    };
  }
  return {
    error: t("error", c.ERROR),
    warn: t("warn", c.WARN),
    info: t("info", c.INFO),
    debug: t("debug", c.DEBUG),
    verbose: t("verbose", c.VERBOSE)
  };
}
var z = function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var n = t.call(e), o, a = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      o && !o.done && (t = n.return) && t.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}, H = function(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}, J = "diag", _ = (
  /** @class */
  function() {
    function e() {
      function r(o) {
        return function() {
          for (var a = [], i = 0; i < arguments.length; i++)
            a[i] = arguments[i];
          var u = h("diag");
          if (u)
            return u[o].apply(u, H([], z(a), !1));
        };
      }
      var t = this, n = function(o, a) {
        var i, u, s;
        if (a === void 0 && (a = { logLevel: c.INFO }), o === t) {
          var f = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return t.error((i = f.stack) !== null && i !== void 0 ? i : f.message), !1;
        }
        typeof a == "number" && (a = {
          logLevel: a
        });
        var p = h("diag"), I = q((u = a.logLevel) !== null && u !== void 0 ? u : c.INFO, o);
        if (p && !a.suppressOverrideMessage) {
          var R = (s = new Error().stack) !== null && s !== void 0 ? s : "<failed to generate stacktrace>";
          p.warn("Current logger will be overwritten from " + R), I.warn("Current logger will overwrite one already registered from " + R);
        }
        return w("diag", I, t, !0);
      };
      t.setLogger = n, t.disable = function() {
        E(J, t);
      }, t.createComponentLogger = function(o) {
        return new Y(o);
      }, t.verbose = r("verbose"), t.debug = r("debug"), t.info = r("info"), t.warn = r("warn"), t.error = r("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
);
function D(e) {
  return Symbol.for(e);
}
var Q = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(r) {
      var t = this;
      t._currentContext = r ? new Map(r) : /* @__PURE__ */ new Map(), t.getValue = function(n) {
        return t._currentContext.get(n);
      }, t.setValue = function(n, o) {
        var a = new e(t._currentContext);
        return a._currentContext.set(n, o), a;
      }, t.deleteValue = function(n) {
        var o = new e(t._currentContext);
        return o._currentContext.delete(n), o;
      };
    }
    return e;
  }()
), Z = new Q(), L = function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var n = t.call(e), o, a = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      o && !o.done && (t = n.return) && t.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}, ee = function(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}, re = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return Z;
    }, e.prototype.with = function(r, t, n) {
      for (var o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return t.call.apply(t, ee([n], L(o), !1));
    }, e.prototype.bind = function(r, t) {
      return t;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), te = function(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var n = t.call(e), o, a = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      o && !o.done && (t = n.return) && t.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}, ne = function(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}, m = "context", ae = new re(), N = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(r) {
      return w(m, r, _.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(r, t, n) {
      for (var o, a = [], i = 3; i < arguments.length; i++)
        a[i - 3] = arguments[i];
      return (o = this._getContextManager()).with.apply(o, ne([r, t, n], te(a), !1));
    }, e.prototype.bind = function(r, t) {
      return this._getContextManager().bind(r, t);
    }, e.prototype._getContextManager = function() {
      return h(m) || ae;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), E(m, _.instance());
    }, e;
  }()
), b;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(b || (b = {}));
var V = "0000000000000000", j = "00000000000000000000000000000000", oe = {
  traceId: j,
  spanId: V,
  traceFlags: b.NONE
}, v = (
  /** @class */
  function() {
    function e(r) {
      r === void 0 && (r = oe), this._spanContext = r;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(r, t) {
      return this;
    }, e.prototype.setAttributes = function(r) {
      return this;
    }, e.prototype.addEvent = function(r, t) {
      return this;
    }, e.prototype.addLink = function(r) {
      return this;
    }, e.prototype.addLinks = function(r) {
      return this;
    }, e.prototype.setStatus = function(r) {
      return this;
    }, e.prototype.updateName = function(r) {
      return this;
    }, e.prototype.end = function(r) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(r, t) {
    }, e;
  }()
), T = D("OpenTelemetry Context Key SPAN");
function x(e) {
  return e.getValue(T) || void 0;
}
function ie() {
  return x(N.getInstance().active());
}
function C(e, r) {
  return e.setValue(T, r);
}
function ue(e) {
  return e.deleteValue(T);
}
function se(e, r) {
  return C(e, new v(r));
}
function G(e) {
  var r;
  return (r = x(e)) === null || r === void 0 ? void 0 : r.spanContext();
}
var ce = /^([0-9a-f]{32})$/i, fe = /^[0-9a-f]{16}$/i;
function pe(e) {
  return ce.test(e) && e !== j;
}
function le(e) {
  return fe.test(e) && e !== V;
}
function k(e) {
  return pe(e.traceId) && le(e.spanId);
}
function de(e) {
  return new v(e);
}
var A = N.getInstance(), $ = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(r, t, n) {
      n === void 0 && (n = A.active());
      var o = !!(t != null && t.root);
      if (o)
        return new v();
      var a = n && G(n);
      return ve(a) && k(a) ? new v(a) : new v();
    }, e.prototype.startActiveSpan = function(r, t, n, o) {
      var a, i, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = t : arguments.length === 3 ? (a = t, u = n) : (a = t, i = n, u = o);
        var s = i ?? A.active(), f = this.startSpan(r, a, s), p = C(s, f);
        return A.with(p, u, void 0, f);
      }
    }, e;
  }()
);
function ve(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var ge = new $(), ye = (
  /** @class */
  function() {
    function e(r, t, n, o) {
      this._provider = r, this.name = t, this.version = n, this.options = o;
    }
    return e.prototype.startSpan = function(r, t, n) {
      return this._getTracer().startSpan(r, t, n);
    }, e.prototype.startActiveSpan = function(r, t, n, o) {
      var a = this._getTracer();
      return Reflect.apply(a.startActiveSpan, a, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var r = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return r ? (this._delegate = r, this._delegate) : ge;
    }, e;
  }()
), he = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(r, t, n) {
      return new $();
    }, e;
  }()
), _e = new he(), M = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(r, t, n) {
      var o;
      return (o = this.getDelegateTracer(r, t, n)) !== null && o !== void 0 ? o : new ye(this, r, t, n);
    }, e.prototype.getDelegate = function() {
      var r;
      return (r = this._delegate) !== null && r !== void 0 ? r : _e;
    }, e.prototype.setDelegate = function(r) {
      this._delegate = r;
    }, e.prototype.getDelegateTracer = function(r, t, n) {
      var o;
      return (o = this._delegate) === null || o === void 0 ? void 0 : o.getTracer(r, t, n);
    }, e;
  }()
), Ae = N.getInstance(), S = "trace", me = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new M(), this.wrapSpanContext = de, this.isSpanContextValid = k, this.deleteSpan = ue, this.getSpan = x, this.getActiveSpan = ie, this.getSpanContext = G, this.setSpan = C, this.setSpanContext = se;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(r) {
      var t = w(S, this._proxyTracerProvider, _.instance());
      return t && this._proxyTracerProvider.setDelegate(r), t;
    }, e.prototype.getTracerProvider = function() {
      return h(S) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(r, t) {
      return this.getTracerProvider().getTracer(r, t);
    }, e.prototype.disable = function() {
      E(S, _.instance()), this._proxyTracerProvider = new M();
    }, e;
  }()
), Se = me.getInstance(), P = D("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function be(e) {
  return e.setValue(P, !0);
}
function we(e) {
  return e.deleteValue(P);
}
function Ee(e) {
  return e.getValue(P) === !0;
}
export {
  N as C,
  _ as D,
  V as I,
  ye as P,
  Z as R,
  b as T,
  D as a,
  c as b,
  Ae as c,
  oe as d,
  j as e,
  M as f,
  h as g,
  le as h,
  k as i,
  pe as j,
  Ee as k,
  we as l,
  w as r,
  be as s,
  Se as t,
  E as u
};
//# sourceMappingURL=suppress-tracing-DlFr5zkG.js.map
